import {
    MDBBtn,
    MDBCard,
    MDBCardText,
    MDBCol,
    MDBRow,
    MDBSwitch,
} from "mdb-react-ui-kit";
import Image from "next/image";
import { FC, useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import { useToggleFavourite } from "@/utils/queries/hooks/useToggleFavourite";
import { useStore } from "@/store/index";
import { checkRating } from "@/utils/common";
import { useIsSM } from "@/utils/hooks/useWindowSizes";
import { useCurrency } from "@/utils/hooks/useCurrency";
import { formatPrice } from "@/utils/common/formatPrice";
import Link from "next/link";
import { starsArray } from "@/utils/star-utils";
import { SearchResponseTO } from "../../models/search";
import styles from "../../styles/search/Search.Card.module.scss";
import userInterfaceSvg from "../../utils/svg-icon/userInterface";
import contactsSvg from "../../utils/svg-icon/contacts";
import socialAndBrandSvg from "../../utils/svg-icon/socialAndBrand";
import { randomUid } from "../../utils/randomIds";
import { slugify } from "../../utils/searchUtils";
import ActivityIcon from "../common/ActivityIcon";
import HeadOverlay from "../home/cards/cardTour/HeadOverlay";

const TourDestinationsCard: FC<{
    cardData: SearchResponseTO;
    premiumGlobal: boolean;
}> = ({ cardData, premiumGlobal }) => {
    const router = useRouter();
    const [isPremium, setIsPremium] = useState<boolean>(premiumGlobal);
    const [moreInfo, setMoreInfo] = useState<boolean>(false);
    const [coverError, setCoverError] = useState<boolean>(false);
    const { FlagFigma } = contactsSvg;

    const { Heart } = userInterfaceSvg;
    const userDetail = useStore(state => state.userState.userDetail);
    // eslint-disable-next-line no-underscore-dangle
    const userId = useStore(state => state.userState.userDetail._id);
    const { mutate: toggle } = useToggleFavourite();
    const { currency } = useCurrency();

    const cardContent = useMemo(() => {
        return isPremium ? cardData.premium : cardData.quality;
    }, [isPremium]);

    const isShow = useMemo(() => {
        return !(cardData.onlyPremium || cardData.onlyQuality);
    }, [cardData]);

    useEffect(() => setIsPremium(premiumGlobal), [premiumGlobal]);

    const checkedRating = checkRating(cardContent?.rating);
    const isSM = useIsSM();

    const dispatchRequestAQuote = useStore(
        state => state.dispatchRequestAQuote
    );

    const [hover, setHover] = useState<boolean>(false);

    const redirectOnClick = () => {
        if (userId) {
            if (hover) {
                router.push({
                    // eslint-disable-next-line sonarjs/no-duplicate-string
                    pathname: "/detail/[slug]",
                    query: {
                        slug: slugify(cardContent.title),
                        // isPremium,
                        // rooms: JSON.stringify([
                        //     {
                        //         adults: 1,
                        //         children: [],
                        //         newborns: 0,
                        //         type: ERoomType.DOUBLE,
                        //     },
                        // ]),
                        // pets: false,
                    },
                });
            }
        } else {
            router.push({
                // eslint-disable-next-line sonarjs/no-duplicate-string
                pathname: "/detail/[slug]",
                query: {
                    slug: slugify(cardContent.title),
                    // isPremium,
                    // rooms: JSON.stringify([
                    //     {
                    //         adults: 1,
                    //         children: [],
                    //         newborns: 0,
                    //         type: ERoomType.DOUBLE,
                    //     },
                    // ]),
                },
            });
        }
    };

    return (
        <MDBCard
            className={
                isPremium
                    ? `${styles.cardBorderPremium}`
                    : `${styles.cardBorderQuality}`
            }
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <MDBRow className="g-0 h-100">
                <MDBCol size={12} md={3} className={styles.imageCol}>
                    <div className={`${styles.imageContainer} h-100 w-100`}>
                        <div className="position-relative h-100">
                            <Image
                                className={`${styles.imageContainer} w-100 hover-cursor`}
                                src={
                                    coverError
                                        ? "/images/tours/across-italy-reduced.jpg"
                                        : cardContent.image
                                }
                                alt="avatar-image"
                                fill
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                quality={75}
                                onError={() => {
                                    setCoverError(true);
                                }}
                                onClick={redirectOnClick}
                            />

                            {hover && cardData.requestAQuote && (
                                <HeadOverlay
                                    id={randomUid()}
                                    rating={0}
                                    isSmall
                                    isRequestAQuote={cardData.requestAQuote}
                                    borderRadiusOverlay={16}
                                    title={cardContent.title ?? "Title"}
                                    onClick={() =>
                                        dispatchRequestAQuote({
                                            type: "SET_REQUEST_A_QUOTE",
                                            payload: {
                                                isOpen: true,
                                                // eslint-disable-next-line no-underscore-dangle
                                                idTour: cardContent.tourId,
                                                title: cardContent.title ?? "",
                                                activities:
                                                    cardContent.requestAQuoteActivities,
                                            },
                                        })
                                    }
                                />
                            )}
                            {userId && (
                                <>
                                    <div
                                        style={{
                                            display: hover ? "block" : "none",
                                            backgroundColor:
                                                "rgba(0, 0, 0, 0.4)",
                                            position: "absolute",
                                            right: "0",
                                            top: "0",
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: isSM
                                                ? "16px 16px 16px 0"
                                                : "16px 0 0 16px",
                                        }}
                                        onClick={redirectOnClick}
                                    />
                                    <MDBBtn
                                        className={`${
                                            userDetail.favouriteTours?.includes(
                                                cardContent.tourId
                                            )
                                                ? styles.buttonLikePressed
                                                : styles.buttonLike
                                        } `}
                                        tag="a"
                                        floating
                                        onClick={() =>
                                            toggle(cardContent.tourId)
                                        }
                                        style={{
                                            display: hover ? "flex" : "none",
                                            position: "absolute",
                                            right: "0",
                                            top: "0",
                                            justifyContent: "center",
                                            margin: "0.5rem",
                                        }}
                                    >
                                        <Heart className="align-self-center" />
                                    </MDBBtn>
                                </>
                            )}
                        </div>
                    </div>
                </MDBCol>
                <MDBCol
                    md={5}
                    style={
                        !isSM
                            ? { borderRight: "0.5px solid #E6E8EC" }
                            : { borderBottom: "0.5px solid #E6E8EC" }
                    }
                >
                    <div className="p-3 d-flex flex-column">
                        <Link
                            href={{
                                // eslint-disable-next-line sonarjs/no-duplicate-string
                                pathname: "detail/[slug]",
                                query: {
                                    slug: slugify(cardContent.title),
                                    // isPremium,
                                    // rooms: JSON.stringify([
                                    //     {
                                    //         adults: 1,
                                    //         children: [],
                                    //         newborns: 0,
                                    //         type: ERoomType.DOUBLE,
                                    //     },
                                    // ]),
                                    // pets: false,
                                },
                            }}
                        >
                            <h3
                                className={styles.cardTitle}
                                onClick={() =>
                                    router.push({
                                        pathname: "/detail/[slug]",
                                        query: {
                                            slug: slugify(cardContent.title),
                                            // isPremium,
                                            // rooms: JSON.stringify([
                                            //     {
                                            //         adults: 1,
                                            //         children: [],
                                            //         newborns: 0,
                                            //         type: ERoomType.DOUBLE,
                                            //     },
                                            // ]),
                                            // pets: false,
                                        },
                                    })
                                }
                            >
                                {cardContent.title}
                            </h3>
                            <div>
                                {checkedRating && (
                                    <div className="d-flex justify-content-start align-items-center mb-3">
                                        {starsArray(cardContent.rating)}

                                        <MDBCardText
                                            className={`${styles.cardSecondaryText} d-flex m-0 fw-bold`}
                                        >
                                            {Number(cardContent.rating)}
                                        </MDBCardText>
                                    </div>
                                )}
                                <MDBRow>
                                    <span
                                        className={styles.cardSecondaryText}
                                    >{`${cardContent.duration} days ${cardContent.nightDuration} nights`}</span>
                                    <MDBRow>
                                        <div>
                                            <FlagFigma />
                                            <span
                                                className={
                                                    styles.cardSecondaryText
                                                }
                                            >{`Destinations: `}</span>
                                            {cardContent.destinations?.map(
                                                (el, i) => (
                                                    <span
                                                        className={
                                                            styles.cardSecondaryText
                                                        }
                                                        key={randomUid()}
                                                    >
                                                        {(i ? ", " : "") + el}
                                                    </span>
                                                )
                                            )}
                                        </div>
                                    </MDBRow>
                                </MDBRow>
                            </div>
                        </Link>
                        <div className="mt-4">
                            <span
                                className={`${styles.cardSecondaryText} me-2`}
                            >
                                {moreInfo ? "Less info " : "More info"}
                            </span>

                            {moreInfo ? (
                                <span
                                    onClick={() => setMoreInfo(!moreInfo)}
                                    className={styles.spanMoreInfo}
                                >
                                    <userInterfaceSvg.ArrowUpSimpleLine />
                                </span>
                            ) : (
                                <span
                                    onClick={() => setMoreInfo(!moreInfo)}
                                    className={styles.spanMoreInfo}
                                >
                                    <userInterfaceSvg.ArrowDownSimpleLine />
                                </span>
                            )}
                            <div className="mt-3">
                                {moreInfo ? (
                                    <>
                                        <p className={styles.cardSecondaryText}>
                                            {cardContent.whatWillYouSee}
                                        </p>
                                        <p className={styles.cardActivityTitle}>
                                            ACTIVITIES
                                        </p>
                                        <div className="d-flex flex-wrap">
                                            {cardContent.activities?.map(el => (
                                                <div
                                                    key={randomUid()}
                                                    className="py-2 d-flex align-items-center"
                                                >
                                                    <ActivityIcon
                                                        alt={el.name}
                                                        borderColor={el.color}
                                                        src={el.icon}
                                                        className="p-2"
                                                        isSmall
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </MDBCol>
                <MDBCol md={4}>
                    <div className="p-3 d-flex flex-column">
                        <Link
                            href={{
                                pathname: "detail/[slug]",
                                query: {
                                    slug: slugify(cardContent.title),
                                    // isPremium,
                                    // rooms: JSON.stringify([
                                    //     {
                                    //         adults: 1,
                                    //         children: [],
                                    //         newborns: 0,
                                    //         type: ERoomType.DOUBLE,
                                    //     },
                                    // ]),
                                    // pets: false,
                                },
                            }}
                        >
                            <div className="d-flex justify-content-center">
                                {isPremium ? (
                                    <div className={styles.cardLabelPremium}>
                                        <div>
                                            <socialAndBrandSvg.SketchLine />
                                        </div>
                                        PREMIUM
                                    </div>
                                ) : (
                                    <div className={styles.cardLabelQuality}>
                                        <div>
                                            <userInterfaceSvg.StarLine />
                                        </div>
                                        QUALITY
                                    </div>
                                )}
                            </div>
                        </Link>
                        {isShow && (
                            <div className="d-flex justify-content-center mt-1 mb-2">
                                <span
                                    className={
                                        isPremium
                                            ? `pe-3 ${styles.cardSecondaryText}`
                                            : `pe-3 ${styles.cardSecondaryTextBold}`
                                    }
                                >
                                    Quality
                                </span>
                                <MDBSwitch
                                    checked={isPremium}
                                    onChange={() => setIsPremium(!isPremium)}
                                    className={styles.customSwitch}
                                />
                                <span
                                    className={
                                        isPremium
                                            ? `ps-3 ${styles.cardSecondaryTextBold}`
                                            : `ps-3 ${styles.cardSecondaryText}`
                                    }
                                >
                                    Premium
                                </span>
                            </div>
                        )}
                        <Link
                            href={{
                                pathname: "detail/[slug]",
                                query: {
                                    slug: slugify(cardContent.title),
                                    // isPremium,
                                    // rooms: JSON.stringify([
                                    //     {
                                    //         adults: 1,
                                    //         children: [],
                                    //         newborns: 0,
                                    //         type: ERoomType.DOUBLE,
                                    //     },
                                    // ]),
                                    // pets: false,
                                },
                            }}
                        >
                            <div
                                className={`${styles.cardPriceContainer} mb-3`}
                            >
                                <div>
                                    <div
                                        className={`${styles.contentPriceBox}`}
                                    >
                                        <div>from</div>
                                        <span className="fs-2">
                                            {formatPrice(
                                                parseFloat(
                                                    cardContent.startingPrice
                                                        ? cardContent.startingPrice
                                                        : cardContent.price
                                                ),
                                                currency
                                            )}
                                        </span>
                                    </div>
                                    <div
                                        className={`${styles.startingPriceStyle}`}
                                    >
                                        Starting price per person in double room
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <div className="d-flex justify-content-center">
                            <div
                                className={styles.watchTourButton}
                                onClick={() =>
                                    router.push({
                                        pathname: "/detail/[slug]",
                                        query: {
                                            slug: slugify(cardContent.title),
                                            // isPremium,
                                            // rooms: JSON.stringify([
                                            //     {
                                            //         adults: 1,
                                            //         children: [],
                                            //         newborns: 0,
                                            //         type: ERoomType.DOUBLE,
                                            //     },
                                            // ]),
                                            // pets: false,
                                        },
                                    })
                                }
                            >
                                watch the tour
                            </div>
                        </div>
                    </div>
                </MDBCol>
            </MDBRow>
        </MDBCard>
    );
};

export default TourDestinationsCard;
